import { set } from 'lodash/fp';
import createReducer from '../../../../../../helpers/createReducer';
import { fetchROItemForView } from '../../../../sagas/routines';
import { resetROItemView } from '../../../../actions/routes/ro-item/view';

const initialState = {
  data: null,
  fetching: false,
  fetched: false
};

const fetchROItemViewHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetROItemViewHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchROItemViewHandler(fetchROItemForView),
  ...resetROItemViewHandler(resetROItemView)
});
